<div
  class="post"
  id="post"
  #post
  [innerHTML]="view.post_content_formatted"
  (click)="onPageClick($event)"
></div>